import { Box } from "@mui/material"
import { AsideSectionContentArea } from "../../../layout"
import { EmptySection, type EmptySectionProps } from "../../EmptySection"

export type AsideSectionEmptyProps = EmptySectionProps

export const AsideSectionEmpty = (props: AsideSectionEmptyProps) => (
  <AsideSectionContentArea height="100%">
    <Box sx={{ display: "grid", placeContent: "center", height: "inherit" }}>
      <EmptySection {...props} />
    </Box>
  </AsideSectionContentArea>
)
